module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-18.5365e928.jpg";